import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  runWorkflowController: [
    'runtimeConstant',
    '$scope',
    '$state',
    '$rootScope',
    '$filter',
    'webApiSettings',
    '$window',
    'authService',
    'flowExecutionService',
    'ETaskTypes',
    '$uibModal',
    'revService',
    'workflowUploadService',
    'flowExecutionService',
    'PermPermissionStore',
    'uploadRevisionService',
    'revisionListService',
    function (
      runtimeConstant,
      $scope,
      $state,
      $rootScope,
      $filter,
      webApiSettings,
      $window,
      authService,
      service,
      ETaskTypes,
      uibModal,
      Revision,
      workflowUploadService,
      flowExecutionService,
      PermPermissionStore,
      uploadRevision,
      revisionListService
    ) {
      'use strict';

      function onbeforeunload(e) {
        if ($scope.notShowMessage === true) {
          $scope.notShowMessage = false;
          return null;
        } else {
          e.returnValue = $filter('translate')('ONBEFOREUNLOAD MESSAGE');
          return $filter('translate')('ONBEFOREUNLOAD MESSAGE');
        }
      }

      function onSave_flowRevisionHistory() {
        $scope.loadHistories();
      }

      function hideGpsDetail() {
        $scope.showGpsDetail = false;
      }

      function toggleGpsDetail(event, gpsItem) {
        $scope.gpsItem = gpsItem;
        $scope.showGpsDetail = true;

        var e = $scope.findParentLi(event.target);

        var width = e.clientWidth;

        var left = angular.element(e).prop('offsetLeft');
        var top = angular.element(e).prop('offsetTop');

        $scope.gpsDetailTop = top + 90;
        $scope.gpsDetailLeft = left + 48 - (250 - width) / 2;
      }

      function findParentLi(element) {
        if (element.className.indexOf('event up') !== -1) {
          return element;
        } else {
          return $scope.findParentLi(element.parentElement);
        }
      }

      function setActions() {
        var revision = $scope.step.revision;
        $scope.allowedExtension = '.' + revision.Extension;
        $scope.idUser = authService.user.id;
        var actionsObjects = [
          {
            key: 'view',
            name: 'VIEW',
            icon: 'md md-pageview',
            action: $scope.view,
            visible: function () {
              return true;
            },
          },
          {
            key: 'download',
            name: 'DOWNLOAD',
            icon: 'md md-file-download',
            action: $scope.download,
            visible: function () {
              return true;
            },
          },
          {
            key: 'edit',
            name: 'EDIT',
            icon: 'md md-edit',
            action: $scope.edit,
              disabled: function () {
              return (
                $scope.step.revision.Certificatas &&
                $scope.step.revision.Certificatas.length > 0
              );
            },
            tooltip: function () {
              return this.disabled()
                ? 'Aguardando Assinaturas'
                : '';
            },
            visible: function () {
              return $scope.step.revision.IdStatus !== 7;
            },
          },
          {
            key: 'update',
            name: 'UPDATE',
            icon: 'md md-edit',
            action: $scope.update,
            visible: function () {
              return false;
            },
          },
          {
            key: 'cancel',
            name: 'CANCEL EDIT',
            icon: 'md md-cancel',
            action: $scope.cancel,
            visible: function () {
              return (
                $scope.step.revision.IdStatus === 7 &&
                $scope.step.revision.RevisionCheckout.IdUser === $scope.idUser
              );
            },
          },
          {
            key: 'sign',
            name: 'SIGN DOCUMENT',
            icon: 'md md-award',
            action: $scope.sign,
            visible: function () {
              return $scope.step.revision.IdStatus !== 7;
            },
          },
          {
            key: 'properties',
            name: 'DOCUMENT PROPERTIES',
            icon: 'md md-settings',
            action: $scope.properties,
            visible: function () {
              return true;
            },
          },
        ];

        var actions = [];
        var required = [];

        switch ($scope.step.element.Type) {
          case ETaskTypes.Review:
            actions = ['view', 'download', 'edit', 'update', 'cancel'];
            if (
              PermPermissionStore.hasPermissionDefinition('DIGITAL_SIGNATURE')
            ) {
              actions.push('sign');
            }
            actions.push('properties');
            required = ['edit', 'update'];
            break;
          case ETaskTypes.Notification:
            actions = ['view', 'download'];
            actions.push('properties');
            break;
          case ETaskTypes.Approve:
            actions = ['view', 'download', 'edit', 'update', 'cancel'];
            if (
              PermPermissionStore.hasPermissionDefinition('DIGITAL_SIGNATURE')
            ) {
              actions.push('sign');
            }
            actions.push('properties');
            required = ['view'];
            break;
          case ETaskTypes.ApproveWithSignature:
            actions = ['view', 'download', 'edit', 'update', 'cancel'];
            if (
              PermPermissionStore.hasPermissionDefinition('DIGITAL_SIGNATURE')
            ) {
              actions.push('sign');
            }
            actions.push('properties');
            required = ['view', 'sign'];
            break;
          case ETaskTypes.Training:
            actions = ['view', 'download'];
            actions.push('properties');
            required = [];
            break;
          case ETaskTypes.Distribution:
            actions = ['view', 'download'];
            actions.push('properties');
            required = [];
            break;
          case ETaskTypes.Analysis:
            actions = ['view', 'download', 'edit', 'update', 'cancel'];
            if (
              PermPermissionStore.hasPermissionDefinition('DIGITAL_SIGNATURE')
            ) {
              actions.push('sign');
            }
            actions.push('properties');
            required = ['view'];
            break;
        }

        var result = [];

        actions.forEach(function (a) {
          var obj = actionsObjects.filter(function (o) {
            return o.key === a;
          })[0];

          obj.required = required.indexOf(a) > -1;
          result.push(obj);
        });

        $scope.actions = result;

        if ($scope.histories.length > 0) {
          $scope.checkDoneActions();
        }
      }

      function getAction(key) {
        var action = $scope.actions.filter(function (a) {
          return a.key === key;
        })[0];

        return action;
      }

      function setForms() {
        if (Object.keys($scope.step.forms).length === 0) {
          var forms = [];
          var isDescriptionRequired = $scope.step.element.IsDescriptionOptional
            ? false
            : true;

          switch ($scope.step.element.Type) {
            case ETaskTypes.Review:
              forms['alteracoes'] = {
                name: 'Alterações',
                value: null,
                required: isDescriptionRequired,
                type: 'textarea',
              };
              break;
            case ETaskTypes.Notification:
              forms['comentarios'] = {
                name: 'Comentário',
                value: '',
                required: true,
                type: 'text',
              };
              break;
            case ETaskTypes.Approve:
            case ETaskTypes.ApproveWithSignature:
              forms['justificativa'] = {
                name: 'Justificativa',
                value: null,
                required: isDescriptionRequired,
                type: 'textarea',
              };
              break;
            case ETaskTypes.Training:
              forms['data'] = {
                name: 'Data',
                value: '',
                required: true,
                type: 'date',
              };
              forms['participantes'] = {
                name: 'Participantes',
                value: [],
                required: true,
                type: 'list',
              };
              break;
            case ETaskTypes.Distribution:
              forms['data'] = {
                name: 'Data',
                value: '',
                required: true,
                type: 'date',
              };
              forms['destinatarios'] = {
                name: 'Destinatários',
                value: [],
                required: true,
                type: 'list',
              };
              break;
            case ETaskTypes.Analysis:
              forms['conclusoes'] = {
                name: 'Conclusões',
                value: null,
                required: isDescriptionRequired,
                type: 'textarea',
              };
              break;
          }

          $scope.step.forms = forms;
        }
      }

      function loadStep() {
        service.loadStep($scope.guid).then(
          function (data) {
            $scope.step = data;
            // Configura o uploader para o caso de edicoes
            $scope.uploader = workflowUploadService.getUploader(
              data.revision.Extension
            );
            $scope.uploader.onAfterAddingFile = $scope.newCheckin;
            $scope.uploader.onAfterAddingAll = $scope.checkinFiles;

            $scope.setActions();
            $scope.setForms();
            $scope.setPath();
            $scope.loading = false;
          },
          function (err) {
            swal.fire({
              title: err.title,
              text: err.text,
              icon: 'error',
              showConfirmButton: true,
              confirmButtonText: $filter('translate')('OK'),
              preConfirm: function () {
                return new Promise(function (resolve) {
                  if (err.redirectToList) {
                    $state.go('flows.base.tasks');
                  }
                  resolve();
                });
              },
            });
          }
        );
      }

      function loadWorkflow() {
        service.loadWorkflow($scope.guid).then(function (data) {
          $scope.workflow = data;
        });
      }

      function loadGps() {
        service.loadGps($scope.guid).then(function (data) {
          $scope.gps = data;
        });
      }

      function getSelectedDecisionOption(index) {
        var task = $scope.gps[index];
        var next = $scope.gps[index + 1];

        if (!task || !next) {
          return null;
        }

        var link = task.element.Links.filter(function (l) {
          return l.IdNextElement === next.idElement;
        })[0];

        return link;
      }

      function getSelectedDecisionColor(index) {
        var link = $scope.getSelectedDecisionOption(index);

        if (link !== null && link !== undefined) {
          return link.CssColor;
        } else {
          return 'blank';
        }
      }

      function loadNextStep() {
        service.loadNextStep($scope.guid).then(function (next) {
          var actions = [];

          if (next.type === ETaskTypes.Decision) {
            for (var i = 0, len = next.links.length; i < len; i++) {
              var link = next.links[i];

              actions.push(link);
            }
          }

          $scope.nextStepActions = actions;
          $scope.nextStep = next;
        });
      }

      function loadHistories() {
        service.loadHistories($scope.guid).then(function (data) {
          $scope.histories = [];

          for (var i = 0, len = data.length; i < len; i++) {
            var item = data[i];

            var step = $scope.histories.filter(function (h) {
              return h.id === item.idExecutionStep;
            })[0];

            if (step === undefined) {
              step = {
                id: item.idExecutionStep,
                step: item.step,
                histories: [],
              };
              $scope.histories.push(step);
            }

            var prev = data[i - 1];
            var isDifferent =
              prev &&
              (prev.idUser !== item.idUser ||
                prev.idStep !== item.idStep ||
                prev.idUser !== item.idUser ||
                prev.action !== item.action);

            item.visible = i === 0 || $scope.showAllHistories || isDifferent;

            step.histories.push(item);
          }

          if ($scope.actions.length > 0) {
            $scope.checkDoneActions();
          }
        });
      }

      function checkDoneActions() {
        for (var i = 0, len = $scope.actions.length; i < len; i++) {
          var action = $scope.actions[i];

          if (action.required) {
            var currentStep = $scope.histories[$scope.histories.length - 1];

            if (currentStep.id === $scope.step.id) {
              for (
                var j = 0, size = currentStep.histories.length;
                j < size;
                j++
              ) {
                var h = currentStep.histories[j];

                if (
                  h.action === action.key &&
                  h.idUser === authService.user.id
                ) {
                  action.done = true;
                }
              }
            }
          }
        }
      }

      function addNew(event, list, value) {
        var scope = angular.element(event.target).scope();
        if (
          value &&
          !list.some(function (l) {
            return l.toLowerCase() === value.toLowerCase();
          })
        ) {
          list.push(value);
        }
        scope.addNewValue = '';
      }

      function addNewKeyPress(event, value, list) {
        if (event.keyCode === 13) {
          $scope.addNew(event, list, value);
        }

        if (event.keyCode === 59) {
          event.preventDefault();
        }
      }

      function canFinishStep() {
        if (
          !$scope.step ||
          !$scope.step.forms ||
          Object.keys($scope.step.forms).length === 0
        ) {
          return;
        }

        var requiredActions =
          $scope.actions.length > 0 &&
          $scope.actions.some(function (a) {
            return a.required === true && !a.done;
          });
        var blankForms =
          $scope.step !== null &&
          $scope.step.forms !== undefined &&
          $scope.step.forms !== null;

        if (blankForms) {
          var keys = Object.keys($scope.step.forms);
          for (var k = 0, len = keys.length; k < len; k++) {
            var f = $scope.step.forms[keys[k]];

            if (
              f.required &&
              ((Array.isArray(f.value) && f.value.length === 0) ||
                !f.value ||
                f.value === '')
            ) {
              blankForms = false;
              break;
            }
          }
        }

        return !$scope.loading && !requiredActions && blankForms;
      }

      function saveHistory(type) {
        service.saveHistory($scope.guid, type).then(function () {
          $scope.loadHistories();
        });
      }

      function view() {
        $scope.saveHistory('view');
        let url = null;

        let revision = $scope.step.revision;

        var dataUri = {
          revision: {
            id: revision.Id,
            idCompany: revision.IdCompany,
            isHistory: revision.IsHistory,
            extension: revision.Extension.toLowerCase(),
            title: revision.Title,
            server: webApiSettings.viewerServer,
            rowGuid: revision.RowGuid,
            userId: authService.user.id,
          },
          token: authService.authentication.token,
          webApiUrl: webApiSettings.apiServiceBaseUri,
          detailsCompany: webApiSettings.detailsCompany,
          infos: {
            canPrint: null,
            canDownload: null,
            urlBase: window.location.href,
          },
          signers: [],
        };

        var signers = [];
        if (revision.IsSigned) {
          revisionListService
            .loadSignersInfo(
              !revision.IsHistory ? revision.Id : revision.IdRevisionHistory,
              revision.Extension,
              revision.HasWorkflow,
              revision.IsHistory
            )
            .then((infoSigners) => {
              signers = infoSigners;
            })
            .catch(() => {})
            .finally(function () {
              dataUri['signers'] = signers;

              if (revision.IdStatus === 3) {
                if (revision.IdRevisionHistory !== undefined) {
                  dataUri.revision.isOldRevision = true;
                  dataUri.revision.id = revision.IdRevisionHistory;
                }
                var encoded = encodeURIComponent(JSON.stringify(dataUri));
                url = webApiSettings.viewerBaseUri + '#/' + encoded;
              } else {
                var encoded = encodeURIComponent(JSON.stringify(dataUri));
                url = webApiSettings.viewerBaseUri + '#/' + encoded;
              }

              $scope.openView(url);
            });
        } else {
          if (revision.IdStatus === 3) {
            if (revision.IdRevisionHistory !== undefined) {
              dataUri.revision.isOldRevision = true;
              dataUri.revision.id = revision.IdRevisionHistory;
            }
            var encoded = encodeURIComponent(JSON.stringify(dataUri));
            url = webApiSettings.viewerBaseUri + '#/' + encoded;
          } else {
            var encoded = encodeURIComponent(JSON.stringify(dataUri));
            url = webApiSettings.viewerBaseUri + '#/' + encoded;
          }

          $scope.openView(url);
        }

        $scope.loading = false;
      }

      function openView(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
      }

      function download() {
        $scope.notShowMessage = true;
        $scope.saveHistory('download');

        service.getDownloadLink($scope.step.revision.Id).then(function (url) {
          top.location.href = url;
          $scope.loading = false;
        });
      }

      function edit() {
        $scope.notShowMessage = true;
        $scope.saveHistory('edit');

        service.editRevision($scope.step.revision.Id).then(function (rev) {
          //Revisão em checkout
          $scope.step.revision = rev;

          service.getDownloadLink($scope.step.revision.Id).then(function (url) {
            top.location.href = url;
            $scope.loading = false;
          });
        });
      }

      function newCheckin(item) {
        if (
          $scope.step.revision.RevisionAdditionalFields === undefined ||
          $scope.step.revision.RevisionAdditionalFields === null
        ) {
          $scope.step.revision.RevisionAdditionalFields = [];
        }

        item.currentDocument = new Revision($scope.step.revision);
        item.revision = new uploadRevision(item);
      }

      function checkinFiles() {
        $scope.modalOpen = true;

        var uploader = $scope.uploader;

        uploader.onBeforeUploadItem = function (item) {
          var authData = authService.authentication;
          var isauth = authData.token !== null && authData.token !== '';

          var keywords = Array.isArray(item.revision.Keywords)
            ? item.revision.Keywords.join(';')
            : null;

          var rev = {
            Id: item.revision.Id,
            IdFolder: item.revision.IdFolder,
            IdDocumentType: item.revision.IdDocumentType,
            Title: item.revision.Title,
            Description: item.revision.Description,
            Keywords: keywords,
            Extension: item.revision.Extension,
            Size: item.revision.Size,
            RevisionAdditionalFields:
              item.revision.RevisionAdditionalFields.map((raf) => {
                return {
                  IdAdditionalField: raf.id,
                  Value: raf.value,
                };
              }),
            NextRevisionDate:
              item.revision.NextRevisionDate !== undefined
                ? item.revision.NextRevisionDate
                : null,
            NotificationDays:
              item.revision.NotificationDays !== undefined &&
              item.revision.NotificationDays !== 0
                ? item.revision.NotificationDays
                : null,
          };

          item.formData = [{ revision: angular.toJson(rev) }];

          if ($scope.workflow) {
            item.formData.push({ workflow: $scope.workflow.IdWorkflow });
            item.formData.push({ isCheckinFromFlowTask: true });
          }

          item.headers = {
            Authorization: isauth ? 'Bearer ' + authData.token : '',
          };
        };

        uploader.onCompleteAll = function () {
          var error = uploader.queue.filter(function (e) {
            return e.isError;
          });
          if (error.length === 0) {
            uploader.clearQueue();

            var action = $scope.actions.filter(function (a) {
              return a.key === 'update';
            })[0];
            action.done = true;

            $scope.saveHistory('update');
            $scope.step.revision.IdStatus = 3;
            $scope.step.revision.RevisionCheckout = null;
            $scope.loading = false;
          }
        };

        $scope.loading = true;
        uploader.uploadAll();
      }

      function cancel() {
        $scope.saveHistory('cancel');

        service.cancelRevisionEdit($scope.step.revision.Id).then(function () {
          $scope.step.revision.IdStatus = 3;
          $scope.step.revision.RevisionCheckout = undefined;
          $scope.loading = false;
        });
      }

      function sign(item) {
        var rev = new Revision($scope.step.revision);
        rev.IdWorkflow = 0;

        var modal = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modules/signing/signDocumentPartial.html',
          controller: 'signDocumentsController',
          windowClass: 'sign-modal-window',
          resolve: {
            revisions: function () {
              return [rev];
            },
            sealData: function () {
              return "";
            },
          },
        });

        modal.result.then(
          function (success) {
            if (success) {
              if (rev.isSigned) {
                $scope.step.revision.IsSigned = true;
                $scope.step.revision.Extension = rev.extension;
                $scope.saveHistory('sign');
                if (item.required) {
                  item.done = true;
                }
              }
            }
          },
          function () {}
        );

        $scope.loading = false;
      }

      function properties() {
        var rev = new Revision($scope.step.revision);

        rev.properties(true, $scope.guid);
        $scope.loading = false;
      }

      function executeAction(item) {
        $scope.loading = true;
        //se for assinatura so vai estar concluida se realmente assinar
        if (item.key === 'sign') {
          item.action(item);
        } else {
          item.action();

          if (item.required) {
            item.done = true;
          }
        }
      }

      function goNextStep(id) {
        $scope.loading = true;

        var forms = [];

        for (
          var i = 0, len = Object.keys($scope.step.forms).length;
          i < len;
          i++
        ) {
          var key = Object.keys($scope.step.forms)[i];
          var f = $scope.step.forms[key];

          forms.push(f);
        }

        var next = {
          IdNextElement: id,
          Forms: forms,
          stringForms: angular.toJson($scope.step.forms),
        };

        service.nextStep($scope.guid, next).then(
          function () {
            $scope.loading = false;
            $state.go('flows.base.tasks');
          },
          function (err) {
            swal.fire({
              title: err.title,
              text: err.text,
              icon: 'error',
              showConfirmButton: true,
              confirmButtonText: $filter('translate')('OK'),
              preConfirm: function () {
                return new Promise(function (resolve) {
                  if (err.redirectToList) {
                    $state.go('flows.base.tasks');
                  }
                  resolve();
                });
              },
            });
          }
        );
      }

      function close() {
        swal
          .fire({
            title: $filter('translate')('CONFIRM CLOSE RUN'),
            text: $filter('translate')('CONFIRM CLOSE RUN MSG'),
            confirmButtonText: $filter('translate')('YES'),
            cancelButtonText: $filter('translate')('NO'),
            showCancelButton: true,
          })
          .then(function () {
            $state.go('flows.base.tasks');
          });
      }

      function init() {
        $scope.loadStep();
        $scope.loadWorkflow();
        $scope.loadGps();
        $scope.loadHistories();
        $scope.loadNextStep();
        $scope.setPath();
      }

      function setPath() {
        if ($scope.step && $scope.step.revision) {
          flowExecutionService
            .getPath($scope.step.revision.IdFolder)
            .then((data) => {
              $scope.path = data;
            });
        }
      }

      function isEditBlocked() {
        return (
          $scope.step &&
          $scope.step.revision &&
          $scope.step.revision.Certificatas &&
          $scope.step.revision.Certificatas.length > 0
        );
      }

      function run() {
        try {
          $scope.guid = $state.params.guid;
          $scope.step = null;
          $scope.title = $state.current.data.title;
          $scope.showAllHistories = false;
          $scope.commenting = false;
          $scope.loading = true;
          $scope.uploader = null;
          $scope.idUser = 0;
          $scope.showGpsDetail = false;
          $scope.gpsDetailTop = '20px';
          $scope.gpsDetailLeft = '40px';
          $scope.gps = [];
          $scope.gpsItem = null;
          $scope.nextStep = null;
          $scope.actions = [];
          $scope.histories = [];
          $scope.path = null;
          $scope.nextStepActions = [];
          $scope.allowedExtension = null;
          $scope.addNewValue = '';

          $window.onbeforeunload = logWrapper(
            onbeforeunload,
            runtimeConstant.isDebugControllersInternals
          );
          $rootScope.$on(
            'save_flowRevisionHistory',
            logWrapper(
              onSave_flowRevisionHistory,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.hideGpsDetail = logWrapper(
            hideGpsDetail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.toggleGpsDetail = logWrapper(
            toggleGpsDetail,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.findParentLi = logWrapper(
            findParentLi,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setActions = logWrapper(
            setActions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getAction = logWrapper(
            getAction,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setForms = logWrapper(
            setForms,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadStep = logWrapper(
            loadStep,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadWorkflow = logWrapper(
            loadWorkflow,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadGps = logWrapper(
            loadGps,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSelectedDecisionOption = logWrapper(
            getSelectedDecisionOption,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSelectedDecisionColor = logWrapper(
            getSelectedDecisionColor,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadNextStep = logWrapper(
            loadNextStep,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadHistories = logWrapper(
            loadHistories,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkDoneActions = logWrapper(
            checkDoneActions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addNew = logWrapper(
            addNew,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addNewKeyPress = logWrapper(
            addNewKeyPress,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canFinishStep = logWrapper(
            canFinishStep,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.saveHistory = logWrapper(
            saveHistory,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.view = logWrapper(
            view,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.openView = logWrapper(
            openView,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.download = logWrapper(
            download,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.edit = logWrapper(
            edit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.newCheckin = logWrapper(
            newCheckin,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.checkinFiles = logWrapper(
            checkinFiles,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sign = logWrapper(
            sign,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.properties = logWrapper(
            properties,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.executeAction = logWrapper(
            executeAction,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goNextStep = logWrapper(
            goNextStep,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.close = logWrapper(
            close,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.setPath = logWrapper(
            setPath,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isEditBlocked = logWrapper(
            isEditBlocked,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
